import PoblacionService from "@/services/PoblacionService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const poblacion = {
    namespace:true,
    state: {poblacions:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListPoblacion({commit},pageNumber){
            return await PoblacionService.getlist(pageNumber).then(
                response=>{    
                    commit('setPoblacions',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListPoblacion({commit},search){          
            return await PoblacionService.getSearch(search).then (
                response =>{                    
                    commit('setPoblacions',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setPoblacions(state,data){
        state.poblacions = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.poblacions.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};